// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🔥 ONLY AUTH PAGES NO SCROLL */
body.auth-page {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: "Inter", sans-serif;
}

/* MAIN WRAPPER */

 .auth-wrapper {
  display: flex;
  height: 100vh;


}

/* 🔥 LEFT SIDE */

 .auth-left {
  flex: 1 1;
  background: linear-gradient(135deg, #f5f7fa, #e3f2fd);
  color: #0d47a1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.auth-left img {
  width: 90px;
}

.auth-left h1 {
  font-size: 32px;
}

.auth-left p {
  font-size: 14px;
  opacity: 0.9;
}

/* 🔥 RIGHT SIDE */
.auth-right {
  flex: 1 1;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* CARD */
.auth-card {
  width: 350px;
  background: white;
  padding: 30px;
  border-radius: 10px;
  border-top: 4px solid #ffc107;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  color: black;
}

.auth-card h3 {
  margin-bottom: 5px;
}

.sub {
  font-size: 14px;
  color: gray;
  margin-bottom: 15px;
}

/* INPUT */
.auth-card input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.auth-card input:focus {
  border-color: #1e88e5;
  outline: none;
}

/* PASSWORD */
.password-field {
  position: relative;
}

.password-field span {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 12px;
  color: #1e88e5;
  cursor: pointer;
}

/* BUTTON */
.btn-primary {
  width: 100%;
  padding: 10px;
  background: linear-gradient(90deg, #1e88e5, #ffc107);
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.btn-primary:hover {
  opacity: 0.9;
}

/* SWITCH */
.switch {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}


.back-button-bottom {
  position: fixed;
  left: 70%;
  bottom: 40px;
  padding: 10px 22px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  color: #333;
  font-size: 14px;
font-weight: bold;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
  
}
.back-button-bottom:hover {
 
  background: white;
  border-color: #999;
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

/* MOBILE */
@media (max-width: 768px) {
  body.auth-page {
    overflow-y: auto;
  }

  .auth-wrapper {
    flex-direction: column;
    height: auto;
    min-height: 60vh;
  }

  .auth-left {
    margin-bottom: 13rem;
    padding: 30px 15px;
    text-align: center;
    justify-content: flex-start;
  }

  .auth-left img {
    width: 70px;
        margin-top: -30px;
  }

  .auth-left h1 {
    margin-left: 50px;
        margin-bottom: 80px;
    font-size: 24px;
  }

  .auth-left p {
    font-size: 13px;
  margin-top: -160px;

  }

  .auth-right {
    margin-top: -280px;
    height: auto;
    padding: 30px 15px;
  }

  .auth-card {
    margin-bottom: 2rem;
    width: 100%;
    max-width: 340px;
    padding: 25px;
  }

  .auth-card h3 {
    font-size: 20px;
  }

  .auth-card input {
    font-size: 14px;
  }

  .btn-primary {
    font-size: 14px;
    padding: 10px;
  }
     .back-button-bottom {
    left: 43%;
    max-width: 340px;
    text-align: center;
    font-size: 13px;
    padding: 12px 20px;
bottom: 7rem;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .auth-wrapper {
    flex-direction: column;
  }

  .auth-left {
    height: 40%;
    padding: 20px;
    text-align: center;
  }

  .auth-left h1 {
    font-size: 28px;
  }

  .auth-right {
    height: 60%;
    padding: 20px;
  }

  .auth-card {
    width: 380px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Account/SignUp.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,iBAAiB;;CAEhB;EACC,aAAa;EACb,aAAa;;;AAGf;;AAEA,iBAAiB;;CAEhB;EACC,SAAO;EACP,qDAAqD;EACrD,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB,iBAAiB;EACf,eAAe;EACf,0CAA0C;EAC1C,0BAA0B;;AAE5B;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;QACP,iBAAiB;EACvB;;EAEA;IACE,iBAAiB;QACb,mBAAmB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB,kBAAkB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;KACG;IACD,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB,YAAY;EACV;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* 🔥 ONLY AUTH PAGES NO SCROLL */\nbody.auth-page {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* MAIN WRAPPER */\n\n .auth-wrapper {\n  display: flex;\n  height: 100vh;\n\n\n}\n\n/* 🔥 LEFT SIDE */\n\n .auth-left {\n  flex: 1;\n  background: linear-gradient(135deg, #f5f7fa, #e3f2fd);\n  color: #0d47a1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.auth-left img {\n  width: 90px;\n}\n\n.auth-left h1 {\n  font-size: 32px;\n}\n\n.auth-left p {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n/* 🔥 RIGHT SIDE */\n.auth-right {\n  flex: 1;\n  background: #f4f6f8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* CARD */\n.auth-card {\n  width: 350px;\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  border-top: 4px solid #ffc107;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n  color: black;\n}\n\n.auth-card h3 {\n  margin-bottom: 5px;\n}\n\n.sub {\n  font-size: 14px;\n  color: gray;\n  margin-bottom: 15px;\n}\n\n/* INPUT */\n.auth-card input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n}\n\n.auth-card input:focus {\n  border-color: #1e88e5;\n  outline: none;\n}\n\n/* PASSWORD */\n.password-field {\n  position: relative;\n}\n\n.password-field span {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 12px;\n  color: #1e88e5;\n  cursor: pointer;\n}\n\n/* BUTTON */\n.btn-primary {\n  width: 100%;\n  padding: 10px;\n  background: linear-gradient(90deg, #1e88e5, #ffc107);\n  border: none;\n  border-radius: 6px;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.btn-primary:hover {\n  opacity: 0.9;\n}\n\n/* SWITCH */\n.switch {\n  text-align: center;\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n\n.back-button-bottom {\n  position: fixed;\n  left: 70%;\n  bottom: 40px;\n  padding: 10px 22px;\n  border-radius: 999px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(8px);\n  color: #333;\n  font-size: 14px;\nfont-weight: bold;\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.25s ease;\n  \n}\n.back-button-bottom:hover {\n \n  background: white;\n  border-color: #999;\n  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);\n}\n\n/* MOBILE */\n@media (max-width: 768px) {\n  body.auth-page {\n    overflow-y: auto;\n  }\n\n  .auth-wrapper {\n    flex-direction: column;\n    height: auto;\n    min-height: 60vh;\n  }\n\n  .auth-left {\n    margin-bottom: 13rem;\n    padding: 30px 15px;\n    text-align: center;\n    justify-content: flex-start;\n  }\n\n  .auth-left img {\n    width: 70px;\n        margin-top: -30px;\n  }\n\n  .auth-left h1 {\n    margin-left: 50px;\n        margin-bottom: 80px;\n    font-size: 24px;\n  }\n\n  .auth-left p {\n    font-size: 13px;\n  margin-top: -160px;\n\n  }\n\n  .auth-right {\n    margin-top: -280px;\n    height: auto;\n    padding: 30px 15px;\n  }\n\n  .auth-card {\n    margin-bottom: 2rem;\n    width: 100%;\n    max-width: 340px;\n    padding: 25px;\n  }\n\n  .auth-card h3 {\n    font-size: 20px;\n  }\n\n  .auth-card input {\n    font-size: 14px;\n  }\n\n  .btn-primary {\n    font-size: 14px;\n    padding: 10px;\n  }\n     .back-button-bottom {\n    left: 43%;\n    max-width: 340px;\n    text-align: center;\n    font-size: 13px;\n    padding: 12px 20px;\nbottom: 7rem;\n  }\n}\n\n@media (max-width: 1024px) and (min-width: 769px) {\n  .auth-wrapper {\n    flex-direction: column;\n  }\n\n  .auth-left {\n    height: 40%;\n    padding: 20px;\n    text-align: center;\n  }\n\n  .auth-left h1 {\n    font-size: 28px;\n  }\n\n  .auth-right {\n    height: 60%;\n    padding: 20px;\n  }\n\n  .auth-card {\n    width: 380px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
